import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { verticalAlign } from '../utils/customPropStyles';
import { imageError } from '../utils/imageError';

const Img = styled<any, any>('img')`
    ${propStyles};
    ${verticalAlign};
    flex-shrink: 0;
`;

interface ImageProps {
    src?: string;
    altText?: string;
    onError?: () => {};
}

@observer
class Image extends React.Component<ImageProps> {
    constructor(props) {
        super(props);
        this.handleImageError = this.handleImageError.bind(this);
    }

    handleImageError(e) {
        imageError(e.target);
    }

    render() {
        const { src, altText } = this.props;
        if (!src) {
            return null;
        }
        return (
            <Img
                src={src}
                onError={this.handleImageError}
                alt={altText}
                {...this.props}
            />
        );
    }
}

export default withTheme(Image) as any;



// WEBPACK FOOTER //
// ./src/Components/Image.tsx